// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"81796441","179":"414323c9","286":"8f71803c","325":"80eada62","454":"888d5a92","481":"ecada8fe","702":"8f71803c"}[chunkId] + ".chunk.css";
};